import { FacetId } from "@grandvisionhq/search";
import { getContentByRef } from "./get-content-by-ref.js";
function getAlgoliaConfigFromBloomreach(pageModel, refPrefix) {
  if (!pageModel) {
    return {
      isEnabled: false
    };
  }
  const component = Object.values(pageModel.page).find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value) => value.label === "Product catalog v2"
  );
  const content = getContentByRef(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component?.models?.document?.$ref,
    pageModel,
    refPrefix
  );
  const isEnabled = !!component;
  const presetQueryString = getPresetQueryString(content);
  const ruleContexts = content?.data?.ruleContexts ?? [];
  const isPrescriptionGlasses = presetQueryString.toLowerCase().includes("frames") || presetQueryString.toLowerCase().includes("sunglasses");
  const facetingAfterDistinct = !isPrescriptionGlasses;
  return {
    isEnabled,
    presetQueryString,
    ruleContexts,
    facetingAfterDistinct
  };
}
function getPresetQueryString(content) {
  if (!content?.data) {
    return "";
  }
  let presetQueryString = (content.data.filterQuery || "").split("#")[0];
  const categoryExternalId = content.data.categoryExternalId || "";
  if (categoryExternalId) {
    const symbol = presetQueryString.includes("?") ? "&" : "?";
    presetQueryString += symbol + `${FacetId.categoryExternalId}=${categoryExternalId}`;
  }
  return presetQueryString;
}
export {
  getAlgoliaConfigFromBloomreach
};
//# sourceMappingURL=get-algolia-config-from-bloomreach.js.map
